<div class="gradient-extendido"></div>

<ion-card-content class="gradient-extendido-recuo">
  <ion-row class="filter">
    <ion-col style="display: flex; justify-content: flex-end; padding: 20px">
      <ion-button
        id="open-modal"
        shape="round"
        fill="outline"
        size="small"
        color="medium"
        class="btn-next"
      >
        {{ "Filtrar" | translate }}
      </ion-button>
    </ion-col>
  </ion-row>

  <div *ngIf="!noticiasAno.length" style="text-align: center">
    <sem-registro [text]="'Nenhuma ' + ('noticia' | nomenclatura | async) + ' encontrada'"></sem-registro>
  </div>

  <ion-accordion-group [value]="noticiasAno[0]?.data">
    <ion-accordion *ngFor="let grupo of noticiasAno" value="{{ grupo.data }}">
      <ion-item slot="header" lines="none" class="header">
        <ion-label class="ion-text-center">
          {{ grupo.data | dateFormat : "MMMM yyyy" }}
        </ion-label>
      </ion-item>

      <div class="border" slot="content">
        <div class="card-top">
          <div class="card-content" *ngFor="let noticia of grupo.noticias">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <img [src]="noticia.imagemApp | image : ''" />
                </ion-col>

                <ion-col size="8" class="header-col">
                  <div>
                    <h3 class="header-text">
                      {{ noticia.titulo }}
                    </h3>

                    <p class="text-resume">
                      {{ noticia.subtitulo }}
                    </p>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row (click)="abrirNoticia(noticia.id)">
                <ion-col size="8">
                  <h3 class="date">
                    {{ noticia.divulgarDe }}
                  </h3>
                </ion-col>

                <ion-col size="4" class="btn-display">
                  <div>
                    <ion-button
                      shape="round"
                      fill="outline"
                      size="small"
                      color="medium"
                      class="btn-next"
                    >
                      {{ texto }}

                      <i class="fas fa-arrow-right icon-arrow"></i>
                    </ion-button>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </div>
      </div>
    </ion-accordion>
  </ion-accordion-group>

  <ion-modal
    trigger="open-modal"
    [initialBreakpoint]="0.7"
    [breakpoints]="[0, 0.25, 0.5, 0.75]"
    handleBehavior="cycle"
  >
    <ng-template>
      <ion-content class="ion-padding">
        <div class="ion-margin-top">
          <form
            class="sample-form validations-form"
            [formGroup]="validations_form"
            (ngSubmit)="onSubmit(validations_form.value)"
          >
            <ion-row>
              <ion-col size="12">
                <ion-datetime
                  presentation="date"
                  formControlName="dataInicio"
                  [showDefaultButtons]="false"
                  [value]="validations_form.get('dataInicio')?.value"
                ></ion-datetime>
              </ion-col>
            </ion-row>

            <div class="down">
              <ion-button
                color="medium"
                class="btn-next"
                expand="block"
                type="submit"
                shape="round"
                fill="outline"
              >
                {{ "Filtrar" | translate }}
              </ion-button>
            </div>
          </form>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-card-content>
